import * as FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getFingerprint = async () => {
  const agent = await FingerprintJS.load({ monitoring: false });
  const data = await agent.get();

  return data.visitorId;
};
